import { Directive, TemplateRef, inject } from '@angular/core';
import type { QpxOverflowMenuItemTemplateContext } from './models';

@Directive({
    selector: 'ng-template[qpxOverflowMenuItemTpl]',
})
export class QpxOverflowMenuItemTemplate {
    public readonly templateRef =
        inject<TemplateRef<QpxOverflowMenuItemTemplateContext>>(TemplateRef);

    static ngTemplateContextGuard(
        _dir: QpxOverflowMenuItemTemplate,
        _ctx: unknown
    ): _ctx is QpxOverflowMenuItemTemplateContext {
        return true;
    }
}
